exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._2g1wegdnxpr4p2qrrwupfz1ymaaw7r4rraudyxxv1wbm6d3ky6ts8jb1uy86rmrt1ruqjbrrq3uns4enhvvvwsak8hrtf849h9pp9gr-AutoWrapper-module-auto-wrapper{width:100%;max-width:1024px;margin:0 auto}", "", {"version":3,"sources":["C:/a/_work/5/s/src/components/AutoWrapper/C:/a/_work/5/s/src/components/AutoWrapper/AutoWrapper.module.scss"],"names":[],"mappings":"AAEA,0IACI,WACA,iBACA,aAAc,CACjB","file":"AutoWrapper.module.scss","sourcesContent":["@import '../../common-scss/variables.scss';\r\n\r\n.auto-wrapper {\r\n    width: 100%;\r\n    max-width: 1024px;\r\n    margin: 0 auto;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"auto-wrapper": "_2g1wegdnxpr4p2qrrwupfz1ymaaw7r4rraudyxxv1wbm6d3ky6ts8jb1uy86rmrt1ruqjbrrq3uns4enhvvvwsak8hrtf849h9pp9gr-AutoWrapper-module-auto-wrapper"
};